<h2 mat-dialog-title i18n>Update User</h2>
<mat-dialog-content>
  <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="15px">
    <mat-form-field>
      <mat-label i18n>User Name</mat-label>
      <input
        matInput
        type="text"
        matTooltip="For domain users use 'domain\username'. For local users use '.\username' or just 'username'."
        i18n-matTooltip
        [(ngModel)]="data.username"
        required
        #userName="ngModel"
      />
      <mat-icon
        class="form-icon"
        *ngIf="
          !isAddClicked || (!userName.errors?.required && !isUserNameExists())
        "
        matSuffix
        >person</mat-icon
      >
      <mat-icon
        color="warn"
        matSuffix
        matTooltipPosition="above"
        matTooltip="User name is mandatory."
        i18n-matTooltip
        *ngIf="
          isAddClicked &&
          (userName.touched || userName.dirty) &&
          userName.errors?.required
        "
        >error_outline</mat-icon
      >
      <mat-icon
        color="warn"
        matSuffix
        matTooltipPosition="above"
        matTooltip="This user name already exists!"
        i18n-matTooltip
        *ngIf="isAddClicked && isUserNameExists()"
        >error_outline</mat-icon
      >
    </mat-form-field>
    <mat-form-field>
      <mat-label i18n>Email</mat-label>
      <input
        matInput
        type="email"
        required
        [(ngModel)]="data.email"
        matTooltip="Please enter a valid email"
        i18n-matTooltip
        required
        #email="ngModel"
        pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
      />
      <mat-icon
        class="form-icon"
        *ngIf="
          !isAddClicked ||
          (!email.errors?.required && email.valid && !emailExists)
        "
        matSuffix
        >email</mat-icon
      >
      <mat-icon
        color="warn"
        matSuffix
        matTooltipPosition="above"
        matTooltip="Email is mandatory."
        i18n-matTooltip
        *ngIf="
          isAddClicked &&
          (email.touched || email.dirty) &&
          email.errors?.required
        "
        >error_outline</mat-icon
      >
      <mat-icon
        color="warn"
        matSuffix
        matTooltipPosition="above"
        matTooltip="Invalid email."
        i18n-matTooltip
        *ngIf="isAddClicked && email.errors?.pattern"
        >error_outline</mat-icon
      >
      <mat-icon
        color="warn"
        matSuffix
        matTooltipPosition="above"
        matTooltip="This user's email already exists!"
        i18n-matTooltip
        *ngIf="isAddClicked && emailExists && !email.errors?.pattern"
        >error_outline</mat-icon
      >
    </mat-form-field>
    <mat-form-field>
      <mat-label i18n>Additional User Names</mat-label>
      <input
        matInput
        type="text"
        matTooltip="Additional User Names (comma-separated)"
        i18n-matTooltip
        [ngModel]="getAdditionalUserNames()"
        (ngModelChange)="data.additionalUsernames = $event.split(',')"
      />
      <mat-icon
        class="form-icon"
        *ngIf="!isAddClicked || aditionalUsersExists() === ''"
        matSuffix
        >people</mat-icon
      >
      <mat-icon
        color="warn"
        matSuffix
        matTooltipPosition="above"
        [matTooltip]="
          'The user name  ' + aditionalUsersExists() + '  is already exists!'
        "
        i18n-matTooltip
        *ngIf="isAddClicked && aditionalUsersExists() !== ''"
        >error_outline</mat-icon
      >
    </mat-form-field>
    <mat-checkbox [(ngModel)]="data.disableNotifications" i18n
      >Disable Notifications</mat-checkbox
    >
    <mat-checkbox
      [ngModel]="data.status === userStatus.Active"
      (ngModelChange)="
        data.status = $event ? userStatus.Active : userStatus.Disabled
      "
      i18n
      >Enabled</mat-checkbox
    >
  </div>
</mat-dialog-content>
<mat-dialog-actions
  fxLayout="row"
  fxLayoutAlign="center center"
  fxLayoutGap="15px"
>
  <button mat-button (click)="update()" *ngIf="!validating" i18n>Update</button>
  <button mat-button *ngIf="validating" disabled i18n>Validating...</button>
  <button mat-button mat-dialog-close i18n>Cancel</button>
</mat-dialog-actions>
